import {createSlice} from '@reduxjs/toolkit';

import {
  coupleIdChecker,
  createCouplePatientsRecord,
  createPatientsRecord,
  deletePatientBill,
  fetchPatientBill,
  fetchPatientDetailsUuid,
  fetchPatientsAppointment,
  fetchPatientsReports,
  fetchSpecificPatient,
  getArchiveData,
  getDashboardData,
  getPatientBills,
  getPatientsBillReportView,
  getPatientsData,
  getPatientsRecords,
  getPatientsReportDatas,
  getPatientsReportView,
  getPrescriptionHistory,
  loginUser,
  postPatientBill,
  postPatientBillMsg,
  postPatientReport,
  updatePatientReport,
  postPrescriptionTemplate,
  putPrescriptionTemplate,
  updatePatient
} from '../Thunk/Actions';

const userSlice = createSlice({
  name: 'user',
  initialState: {
    sidebarnav: 'true',
    sidebar: 'DashBoard',
    userdata: '',
    admin_access: [],
    login_role: '',
    loader: 'false',
    popupalert: 'false',
    purpose: '',
    dvtabs: 'About',
    editadminuser: '',
    editadminuserid: '',
    patientid: '',
    doctorsDetailsList: '',
    patientsData: '',
    demo: '',
    globalResponse: '',
    emptyTemplateHtml: '',
    emptyTemplateEdit: false,
    updateTemplateName: '',
    editdoctoruser: '',
    patientTab: 'History',
    prescriptionType: '',
    prescriptionId: '',
    recordpopup: false,
    menuPrescriptionTab: 'prescription',
    reportViewId: '',
    reportViewTypeData: '',
    secondPageTemplateIdData: '',
    appointmentDate: '',
    reportViewDate: '',
    showEditPopup: false
  },
  reducers: {
    sidenav(state, action) {
      state.sidebarnav = action.payload;
    },
    setLoginRole(state, action) {
      state.login_role = action.payload;
    },
    sidebar(state, action) {
      state.sidebar = action.payload;
    },
    userdata(state, action) {
      state.userdata = action.payload;
    },
    admin_access(state, action) {
      state.admin_access = action.payload;
    },
    loader(state, action) {
      state.loaderstate = action.payload;
    },
    popupalert(state, action) {
      state.popupalert = action.payload;
    },
    dvtabs(state, action) {
      state.dvtabs = action.payload;
    },
    editadminuser(state, action) {
      state.edituser = action.payload;
    },
    editadminuserid(state, action) {
      state.edituserid = action.payload;
    },
    patientid: (state, action) => {
      state.patientid = action.payload;
    },
    purpose: (state, action) => {
      state.purpose = action.payload;
    },
    resetResponse: (state, action) => {
      state.globalResponse = action.payload;
    },
    editdoctoruser: (state, action) => {
      state.editdoctoruser = action.payload;
    },
    updatePatientTab: (state, action) => {
      state.patientTab = action.payload;
    },
    setEmptyTemplateHtml(state, action) {
      state.emptyTemplateHtml = action.payload;
    },
    setEmptyTemplateEdit(state, action) {
      state.emptyTemplateEdit = action.payload;
    },
    setTemplateName(state, action) {
      state.templateName = action.payload;
    },
    setAppointmentDate(state, action) {
      state.appointmentDate = action.payload;
    },
    updatePrescriptionType: (state, action) => {
      state.prescriptionType = action.payload;
    },
    updatePrescriptionId: (state, action) => {
      state.prescriptionId = action.payload;
    },
    CRUDRecordPopup: (state, action) => {
      state.recordpopup = action.payload;
    },
    menuPrescriptionTab: (state, action) => {
      state.menuPrescriptionTab = action.payload;
    },
    reportViewId: (state, action) => {
      state.reportViewId = action.payload;
    },
    reportViewType: (state, action) => {
      state.reportViewTypeData = action.payload;
    },
    secondPageTemplateId: (state, action) => {
      state.secondPageTemplateIdData = action.payload;
    },
    setDoctorsDetailsList: (state, action) => {
      state.doctorsDetailsList = action.payload;
    },
    setReportViewDate(state, action) {
      state.reportViewDate = action.payload;
    },
    setPatientDataForCouple(state, action) {
      state.patientsData = action.payload;
    },
    setShowEditPopup(state, action) {
      state.showEditPopup = action.payload;
    }
  },
  extraReducers: builder => {
    builder
      .addCase(loginUser.pending, (state, action) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loading = false;
        state.globalResponse = action.payload;
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(deletePatientBill.pending, state => {
        state.loading = true;
      })
      .addCase(deletePatientBill.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deletePatientBill.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(getArchiveData.pending, state => {
        state.loading = true;
      })
      .addCase(getArchiveData.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(getArchiveData.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(createCouplePatientsRecord.pending, state => {
        state.loading = true;
      })
      .addCase(createCouplePatientsRecord.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(createCouplePatientsRecord.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(getPatientBills.pending, state => {
        state.loading = true;
      })
      .addCase(getPatientBills.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(getPatientBills.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(fetchPatientsReports.pending, state => {
        state.loading = true;
      })
      .addCase(fetchPatientsReports.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(fetchPatientsReports.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(postPatientBillMsg.pending, state => {
        state.loading = true;
      })
      .addCase(postPatientBillMsg.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(postPatientBillMsg.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(getPatientsData.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPatientsData.fulfilled, (state, action) => {
        state.loading = false;
        state.patientsData = action.payload;
      })
      .addCase(getPatientsData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      //
      .addCase(createPatientsRecord.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createPatientsRecord.fulfilled, (state, action) => {
        state.loading = false;
        state.globalResponse = action.payload;
      })
      .addCase(createPatientsRecord.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      // getDashboardData
      .addCase(getDashboardData.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getDashboardData.fulfilled, (state, action) => {
        state.loading = false;
        state.globalResponse = action.payload;
      })
      .addCase(getDashboardData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      // fetchSpecificPatient;
      .addCase(fetchSpecificPatient.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSpecificPatient.fulfilled, (state, action) => {
        state.loading = false;
        state.patientsData = action.payload;
      })
      .addCase(fetchSpecificPatient.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      // updatePatient;
      .addCase(updatePatient.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updatePatient.fulfilled, (state, action) => {
        state.loading = false;
        state.globalResponse = action.payload;
      })
      .addCase(updatePatient.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      // getPrescriptionHistory
      .addCase(getPrescriptionHistory.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPrescriptionHistory.fulfilled, (state, action) => {
        state.loading = false;
        state.globalResponse = action.payload;
      })
      .addCase(getPrescriptionHistory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      // getPatientsRecords
      .addCase(getPatientsRecords.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPatientsRecords.fulfilled, (state, action) => {
        state.loading = false;
        state.globalResponse = action.payload;
      })
      .addCase(getPatientsRecords.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      // postPrescriptionTemplate
      .addCase(postPrescriptionTemplate.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postPrescriptionTemplate.fulfilled, (state, action) => {
        state.loading = false;
        state.globalResponse = action.payload;
      })
      .addCase(postPrescriptionTemplate.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      // putPrescriptionTemplate
      .addCase(putPrescriptionTemplate.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(putPrescriptionTemplate.fulfilled, (state, action) => {
        state.loading = false;
        state.globalResponse = action.payload;
      })
      .addCase(putPrescriptionTemplate.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      // getPatientReports
      .addCase(getPatientsReportDatas.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPatientsReportDatas.fulfilled, (state, action) => {
        state.loading = false;
        state.globalResponse = action.payload;
      })
      .addCase(getPatientsReportDatas.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      // patient report view
      .addCase(getPatientsReportView.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPatientsReportView.fulfilled, (state, action) => {
        state.loading = false;
        state.globalResponse = action.payload;
      })
      .addCase(getPatientsReportView.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      // post patient report
      .addCase(postPatientReport.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postPatientReport.fulfilled, (state, action) => {
        state.loading = false;
        state.globalResponse = action.payload;
      })
      .addCase(postPatientReport.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(updatePatientReport.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updatePatientReport.fulfilled, (state, action) => {
        state.loading = false;
        state.globalResponse = action.payload;
      })
      .addCase(updatePatientReport.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      // post patient billing
      .addCase(postPatientBill.pending, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(postPatientBill.fulfilled, (state, action) => {
        state.loading = false;
        state.globalResponse = action.payload;
        // state.error = action.error.message;
      })
      .addCase(postPatientBill.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      // fetch patient billing
      .addCase(fetchPatientBill.pending, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(fetchPatientBill.fulfilled, (state, action) => {
        state.loading = false;
        state.globalResponse = action.payload;
        // state.error = action.error.message;
      })
      .addCase(fetchPatientBill.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      // fetch patient billing view
      .addCase(getPatientsBillReportView.pending, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(getPatientsBillReportView.fulfilled, (state, action) => {
        state.loading = false;
        state.globalResponse = action.payload;
      })
      .addCase(getPatientsBillReportView.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      // fetch patient details using UUID
      .addCase(fetchPatientDetailsUuid.pending, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(fetchPatientDetailsUuid.fulfilled, (state, action) => {
        state.loading = false;
        state.globalResponse = action.payload;
      })
      .addCase(fetchPatientDetailsUuid.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      // fetch coupleIdChecker
      .addCase(coupleIdChecker.pending, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(coupleIdChecker.fulfilled, (state, action) => {
        state.loading = false;
        state.globalResponse = action.payload;
      })
      .addCase(coupleIdChecker.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchPatientsAppointment.pending, (state, action) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPatientsAppointment.fulfilled, (state, action) => {
        state.loading = false;
        state.globalResponse = action.payload;
      })
      .addCase(fetchPatientsAppointment.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  }
});

export const {
  setLoginRole,
  setEmptyTemplateHtml,
  setEmptyTemplateEdit,
  setTemplateName,
  setDoctorsDetailsList,
  getUser,
  setUser,
  setError,
  logOut,
  sidenav,
  sidebar,
  userdata,
  admin_access,
  popupalert,
  loader,
  dvtabs,
  editadminuser,
  editadminuserid,
  editdoctoruser,
  patientid,
  purpose,
  resetResponse,
  updatePatientTab,
  updatePrescriptionType,
  updatePrescriptionId,
  CRUDRecordPopup,
  menuPrescriptionTab,
  patientReportCreateredux,
  reportViewId,
  reportViewType,
  secondPageTemplateId,
  setAppointmentDate,
  setReportViewDate,
  setPatientDataForCouple,
  setShowEditPopup
} = userSlice.actions;

export const prescriptionType = updatePrescriptionType;
export const shareTemplate = (payload) => ({ type: 'user/shareTemplate', payload });

export default userSlice.reducer;

